import { useMessageThreadInfo } from "../../../hooks/useMessageThreadInfo";
import { Redo } from "lucide-react";
import "./HumanMessageCanvasFollowUp.css";
import "../../common/MentionText.css";
import { HumanMessageCanvasFollowUp as HumanMessageType } from "winslow-core";
import { useDispatch } from "react-redux";
import {
  setPrompt,
  openEmployeeProfileSidebar,
} from "../../../redux/features/agent/agentSlice";
import { ThreadInfo } from "../ThreadInfo";
import { MentionText } from "../../common/MentionText";
import { MessageThreadType } from "winslow-core";

type HumanMessageCanvasFollowUpProps = {
  message: HumanMessageType;
  handleStartNewThread: (
    personaId: string | null,
    employeeId: string | null
  ) => void;
};

export const HumanMessageCanvasFollowUp = ({
  message,
  handleStartNewThread,
}: HumanMessageCanvasFollowUpProps) => {
  const contextInfo = useMessageThreadInfo(message.thread);

  const dispatch = useDispatch();

  const handleThreadInfoClick = (employeeId?: string) => {
    if (employeeId) {
      dispatch(openEmployeeProfileSidebar({ employeeId }));
    }
  };

  return (
    <div className="human-message-canvas-follow-up-prompt-container">
      <div className="human-message-canvas-follow-up-prompt-hover-icon">
        <Redo
          size={16}
          onClick={() => {
            console.log(
              "message.message.kwargs.content",
              message.message.content
            );
            dispatch(setPrompt(message.message.content));
            const thread = message?.thread;
            handleStartNewThread(
              thread?.personaId || null,
              thread?.employeeId || null
            );
          }}
        />
      </div>
      <div
        id={"human_message_" + message.id.toString()}
        className="human-message-canvas-follow-up-prompt">
        <MentionText text={message.message.content} />
      </div>

      {contextInfo && (
        <ThreadInfo
          showAvatar={true}
          avatar={contextInfo.avatar}
          label={contextInfo.label}
          onClick={handleThreadInfoClick}
          employeeId={contextInfo.employeeId}
          clickable={
            contextInfo.threadType === MessageThreadType.EMPLOYEE &&
            !!contextInfo.employeeId
          }
        />
      )}
    </div>
  );
};
